import { PaymentCardInformation } from '@/src/app/main/(tabs)/card/card-management/_common/paymentCardInformation'
import OptionItemSelector from '@/src/app/main/(tabs)/card/card-management/payment/optionItemSelector'
import { PlaidItemStatus } from '@api/mesa/graphql'
import { View, Text, StyleSheet } from 'react-native'
import { Loading } from '@/src/common/components/Loading'
import type { BasePaymentMethod } from '@/src/experiences/card-payments/providePaymentMethods'
import { Plaid } from '@acre-rewards/lib'
import {
  addNewAccountButtonIcon,
  addNewAccountButtonText,
} from '@/src/app/main/(tabs)/card/card-management/_common/AccountSection'
import { mesaColorNames } from '@/src/common/theme'

/** @todo /@deprecate this {@link BasePaymentMethod} */
export type ExternalAccount = BasePaymentMethod

export function FundingSourceSelector({
  accounts,
  onAddNewAccountPress,
  loading = false,
  onAccountSelectedChange,
  selectedAccount,
  title,
  promptForUpdate = false,
  requiredProducts = [],
}: {
  loading?: boolean
  accounts: ExternalAccount[]
  onAddNewAccountPress?: () => void
  onAccountSelectedChange: (accountId: ExternalAccount) => void
  selectedAccount?: ExternalAccount
  title?: string
  promptForUpdate?: boolean
  requiredProducts?: typeof Plaid.Products.options
}) {
  return (
    <PaymentCardInformation title={title || 'Funding Source'} containerStyle={styles.container}>
      {loading && (
        <View style={styles.loadingOverlay}>
          <Loading />
        </View>
      )}

      {!accounts.length && (
        <View style={styles.noAccountsContainer}>
          <Text style={styles.noAccountsText}>No Accounts Found</Text>
        </View>
      )}

      {accounts.map((account) => {
        const { isVerified } = account
        const subtitle = isVerified ? undefined : 'Pending verification'
        const isProductAvailable =
          requiredProducts.length > 0
            ? requiredProducts.every((product) => account.products.includes(product))
            : true

        return (
          <OptionItemSelector
            onItemPress={() => onAccountSelectedChange(account)}
            key={account.key}
            title={account.last4}
            label={account.name}
            isSelected={selectedAccount?.key === account.key}
            subtitle={subtitle}
            isPending={!isVerified}
            isUpdateRequired={
              (promptForUpdate && account.status === PlaidItemStatus.UpdateRequired) ||
              !isProductAvailable
            }
          />
        )
      })}

      <OptionItemSelector
        onItemPress={onAddNewAccountPress}
        icon={addNewAccountButtonIcon}
        title={addNewAccountButtonText}
        isSelected={false}
        withBorder={false}
        titleStyle={styles.addAccountTitleStyle}
      />
    </PaymentCardInformation>
  )
}

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 16,
    position: 'relative',
  },
  loadingOverlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 10,
    opacity: 0.9,
  },
  noAccountsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 16,
  },
  noAccountsText: {
    color: mesaColorNames['Greyscale/600 #505D64'],
  },
  addAccountTitleStyle: {
    fontWeight: '400',
  },
})
